<div class="loading-indicator no-delay align-items-center justify-content-center row">
  <div class="lds-ellipsis">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
